import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle, FiXCircle } = FiIcons;

const ProblemSection = () => {
  const problems = [
    "Sudah punya website, tapi tidak menghasilkan leads",
    "Sulit ditemukan di Google & Google Maps",
    "Promosi jalan, tapi tidak terukur",
    "Banyak pekerjaan manual yang menyita waktu",
    "Sudah coba digital marketing, tapi tidak ada arah strategi"
  ];

  return (
    <section className="py-24 relative overflow-hidden bg-[#0A192F]">
      <div className="bright-glow -left-40 top-1/4 opacity-20"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            Apakah Bisnis Anda <span className="text-orange-500">Mengalami Ini?</span>
          </h2>
          <div className="w-20 h-1.5 bg-orange-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {problems.map((problem, idx) => (
            <div key={idx} className="bg-white/5 border border-white/10 p-8 rounded-[2rem] flex items-start space-x-4 hover:bg-white/10 transition-all group">
              <SafeIcon icon={FiXCircle} className="text-orange-500 text-2xl mt-1 flex-shrink-0 group-hover:scale-110 transition-transform" />
              <p className="text-xl text-gray-200 font-bold leading-tight">{problem}</p>
            </div>
          ))}
          <div className="lg:col-span-1 bg-gradient-to-br from-orange-600 to-orange-800 p-8 rounded-[2rem] flex flex-col justify-center">
             <div className="flex items-center mb-4">
               <SafeIcon icon={FiAlertCircle} className="text-white text-3xl mr-3" />
               <h3 className="text-2xl font-black text-white">The Truth</h3>
             </div>
             <p className="text-white font-bold text-lg leading-relaxed">
               Jika iya, masalahnya bukan di "kurang promosi". Masalahnya adalah belum punya sistem digital yang benar.
             </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;